import React, { useMemo, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCurrency } from '../../context/CurrencyContext';
import { currencyFlagUrl } from '../../utils/currencyFlags';
import './MobilePaymentCurrencyPage.css';

const LETTERS = '#ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');

export default function MobilePaymentCurrencyPage() {
  const navigate = useNavigate();
  const { currencies, selectedCurrency, changeCurrency } = useCurrency();

  const { sections, indexLetters } = useMemo(() => {
    const list = (currencies || [])
      .slice()
      .sort((a, b) => a.code.localeCompare(b.code, 'en'));
    const byLetter = {};
    list.forEach((c) => {
      const L = (c.code[0] || '#').toUpperCase();
      const k = /[A-Z]/.test(L) ? L : '#';
      if (!byLetter[k]) byLetter[k] = [];
      byLetter[k].push(c);
    });
    const letters = Object.keys(byLetter).sort((a, b) => {
      if (a === '#') return -1;
      if (b === '#') return 1;
      return a.localeCompare(b);
    });
    return { sections: byLetter, indexLetters: letters };
  }, [currencies]);

  const jumpTo = useCallback(
    (letter) => {
      const el = document.getElementById(`mcur-sec-${letter}`);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        const next = indexLetters.find((L) => L >= letter) || indexLetters[0];
        if (next) {
          const el2 = document.getElementById(`mcur-sec-${next}`);
          el2?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    },
    [indexLetters]
  );

  return (
    <div className="mcur-page">
      <div className="mcur-header">
        <button type="button" className="mcur-back" onClick={() => navigate(-1)} aria-label="Back">
          <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2.2">
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </button>
        <h1 className="mcur-title">Payment currency</h1>
      </div>
      <div className="mcur-banner">
        <span className="mcur-banner-icon">i</span>
        <p>You can view the product price in the following currencies:</p>
      </div>
      <h2 className="mcur-sub">Supported payment currencies</h2>
      <div className="mcur-main">
        <div className="mcur-list">
          {indexLetters.map((letter) => (
            <section key={letter} id={`mcur-sec-${letter}`} className="mcur-section">
              {sections[letter].map((c) => (
                <button
                  key={c.code}
                  type="button"
                  className={
                    c.code === selectedCurrency?.code
                      ? 'mcur-item mcur-item--active'
                      : 'mcur-item'
                  }
                  onClick={() => {
                    changeCurrency(c.code);
                    navigate(-1);
                  }}
                >
                  {currencyFlagUrl(c.code) ? (
                    <img className="mcur-flag" src={currencyFlagUrl(c.code)} alt="" />
                  ) : (
                    <span className="mcur-flag mcur-flag--ph" />
                  )}
                  <div className="mcur-item-text">
                    <div className="mcur-code">{c.code}</div>
                    <div className="mcur-name">{c.name}</div>
                  </div>
                </button>
              ))}
            </section>
          ))}
        </div>
        <div className="mcur-index" aria-hidden="true">
          {LETTERS.map((L) => {
            const has = indexLetters.includes(L);
            return (
              <button
                key={L}
                type="button"
                className={has ? 'mcur-ix mcur-ix--on' : 'mcur-ix mcur-ix--off'}
                onClick={() => jumpTo(L)}
              >
                {L}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
